<template>
  <v-container>
    <div v-if="showBaseCMP">
      <template v-if="$route.name ==='CardCompanyTypes' && ['machine-card', 'tradecertificate-card'].includes($route.params.type)">      
        <GoBackAtTop          
          :to="{name: 'CompanyOrderCardStart', params: {id: this.companyId, personId: this.personId}}"
          :label="$t('labels.card-orders')" />
        
        <h1 class="mt-2">{{$route.params.type === 'tradecertificate-card' ? $t('order-card.order.title2') : $t('order-card.order.title') }}</h1>
              
      </template>
      <template v-else>      
        <template v-if="$route.params.type === 'tradecertificate-card'">
          <GoBackAtTop :to="{name: 'MyOrderCardStart'}" :label="$t('labels.card-orders')"/>          
          <h1 class="mt-2">{{ $t('order-card.order.title2') }}</h1>                  
        </template>
        <template v-else>
          <GoBackAtTop          
          :to="{name: 'MyOrderCardStart'}"
          :label="$t('labels.card-orders')"
        />
          <h1 class="mt-2">{{ $t('order-card.card-types') }}</h1>
        </template>
        
      </template>            
      <h2 class="mt-n1">
          {{ $t('order-card.card-types-question') }}
      </h2>    

      <ActionButton @click="goTo($route.params.type)">{{ $t('order-card.types-b8') }}</ActionButton>
      <ActionButton class="mt-4" @click="goTo($route.params.type, { reasonId: 1 })">{{ $t('order-card.types-b6') }}</ActionButton>
      <ActionButton class="mt-4" @click="printingErrors()">{{ $t('order-card.types-b7') }}</ActionButton>
    </div>
    <FakeOrderCard
      v-if="showFakeCMP"
      :detail="detail"
      @showBase="
        showBaseCMP = true
        showFakeCMP = false
      "
    />
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import API from '@/services/api.js'
import GoBackAtTop from '@/components/Common/GoBackAtTop'
import ActionButton from '@/components/Common/ActionButton'
import FakeOrderCard from '@/components/CardOrders/FakeOrderCard'
export default {
  components: {
    ActionButton,
    GoBackAtTop,
    FakeOrderCard
  },
  data() {
    return {
      showBaseCMP: true,
      showFakeCMP: false,
      companyId: null,
      apprenticenshipId: null,
      personId: null
    }
  },
  created() {
    if(!(this.$route.params && this.$route.params.type && this.$route.params.type!='' || this.$route.params.companyId))
      this.$router.push("/");
    if (this.$route && this.$route.params) {
      this.companyId = this.$route.params.companyId ? this.$route.params.companyId : null
      this.personId = this.$route.params.personId ? this.$route.params.personId : null
      this.apprenticenshipId = this.$route.params.apprenticenshipId ? this.$route.params.apprenticenshipId : null
    }
  },
  computed: {
    isCompanyOrder() {
      return Boolean(this.$route && this.$route.params && this.$route.params.companyId)
    },
    detail() {
      return {
        title: this.$t('order-card.types-b7'),
        // subtitle: this.$t('order-card.tc-printing-erorrs-subtitle'),
        message: {
          title: this.$t('order-card.c-message-printing-erorrs-title'),
          text1: this.$t('order-card.c-message-printing-erorrs-text1'),
          link: this.$t('order-card.c-message-printing-erorrs-link'),
          text2: (
            this.$route.params.type === 'tradecertificate-card' ? 
            this.$t('order-card.c-message-printing-erorrs-text2') : 
            this.$t('order-card.c-message-printing-erorrs-text3')
          )
        }
      }
    }
  },

  methods: {
    changedName() {
      this.showBaseCMP = false
      this.showFakeCMP = true
      if(this.$route.params.type=='tradecertificate-card'){
        this.detail = {
            title: this.$t('order-card.tc-change-skat-title'),
            subtitle: this.$t('order-card.tc-change-skat-subtitle'),
            message: {
              title: this.$t('order-card.tc-change-skat-message-title'),
              text1: this.$t('order-card.tc-change-skat-message-text1'),
              link: this.$t('order-card.tc-change-skat-message-link'),
              text2: this.$t('order-card.tc-change-skat-message-text2')
            }
          }
      }
      else if(this.$route.params.type=='machine-card'){
        this.detail = {
            title: this.$t('order-card.change-skat-title'),
            subtitle: this.$t('order-card.change-skat-subtitle'),
            message: {
              title: this.$t('order-card.change-skat-message-title'),
              text1: this.$t('order-card.change-skat-message-text1'),
              link: this.$t('order-card.change-skat-message-link'),
              text2: this.$t('order-card.change-skat-message-text2')
            }
          }
      }
      else if(this.isCompanyOrder) {
        this.detail = {
            title: this.$t('order-card.c-change-skat-title'),
            subtitle: this.$t('order-card.c-change-skat-subtitle'),
            message: {
              title: this.$t('order-card.c-change-skat-message-title'),
              text1: this.$t('order-card.c-change-skat-message-text1'),
              link: this.$t('order-card.c-change-skat-message-link'),
              text2: this.$t('order-card.c-change-skat-message-text2')
            
          }
        }
      }
      else { this.$router.push("/"); }      
    },
    printingErrors() {
      this.showBaseCMP = false
      this.showFakeCMP = true
    },

    goTo(type, reason) {
      this.isCompanyOrder
        ? this.$nextTick(() => {
            this.$router.push({
              name: 'OrderCardCompany',
              params: {
                companyId: this.companyId, 
                personId: this.personId,
                apprenticenshipId:this.apprenticenshipId, 
                type: type, 
                reasonId: reason?.reasonId 
              }
            })
          })
        : this.$nextTick(() => {
            this.$router.push({
              name: 'OrderCard',
              params: { 
                personId: this.personId, 
                type: type, 
                reasonId: reason?.reasonId 
              }
            })
          })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>